import React from 'react'
import FormUpdate from './formUpdate'

const CreateDevice = (props) => {
    return (
        <FormUpdate {...props} />
    )
}

export default CreateDevice;
